export const mediaItems = [
  {
    id: 1,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20entertainment%20news%20interview%20studio%20two%20people%20talking%20warm%20lighting%20professional%20broadcast%20setup%20clean%20composition&width=640&height=360&seq=media-1&orientation=landscape',
    title: '独家专访：新晋影后谈演艺之路',
    desc: '从龙套到影后，她用了十二年。独家对话揭秘那些不为人知的坚持与选择。',
    duration: '28:45',
    views: '23.6万',
    tag: '独家',
  },
  {
    id: 2,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20behind%20the%20scenes%20crew%20working%20cameras%20equipment%20warm%20lighting%20production%20atmosphere%20making%20of%20documentary%20style&width=640&height=360&seq=media-2&orientation=landscape',
    title: '《乘风破浪》后台花絮：姐姐们的真实日常',
    desc: '镜头之外的训练、嬉闹和深夜谈心，比正片更精彩的后台故事合集。',
    duration: '15:22',
    views: '18.9万',
    tag: '花絮',
  },
  {
    id: 3,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20music%20video%20production%20set%20singer%20in%20recording%20booth%20professional%20audio%20equipment%20warm%20moody%20lighting%20creative%20atmosphere&width=640&height=360&seq=media-3&orientation=landscape',
    title: '新歌首发：某天王回归之作MV全球首播',
    desc: '时隔三年回归乐坛，MV投资破千万，视觉效果堪比电影大片。',
    duration: '04:12',
    views: '56.3万',
    tag: '首发',
  },
  {
    id: 4,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20talk%20show%20roundtable%20discussion%20four%20people%20seated%20engaging%20conversation%20warm%20studio%20lighting%20professional%20broadcast%20set&width=640&height=360&seq=media-4&orientation=landscape',
    title: '圆桌讨论：2026年的娱乐圈会更好吗？',
    desc: '资深媒体人、制片人和演员三方对话，理性探讨行业现状与未来走向。',
    duration: '42:10',
    views: '9.7万',
    tag: '深度',
  },
];